export default __webpack_public_path__ + "12c0d19336469d45c9362b4ab8c06ff3.png";